var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg32 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "32")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M77.53,45.63q0,14.52,0,29c0,3.25-.07,3.31-3.4,3.31-1.83,0-3.66,0-5.5,0-1.06,0-1.85-.39-1.86-1.53s.75-1.58,1.82-1.57c1.49,0,3-.07,4.46,0,1.13.08,1.41-.28,1.4-1.4,0-9.33,0-18.67,0-28s0-18.55,0-27.83c0-1.28-.28-1.61-1.58-1.59-4.87.09-9.73,0-14.6,0-1.17,0-2.35-.08-2.37-1.53S57.06,13,58.24,13c5.61,0,11.22,0,16.83,0,2,0,2.45.44,2.45,2.54Q77.53,30.6,77.53,45.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.92,78H15c-2,0-2.4-.45-2.41-2.41,0-5.67,0-11.34,0-17,0-1.13.18-2.19,1.53-2.19s1.59,1,1.58,2.16c0,4.81,0,9.62,0,14.43,0,1.48.24,2,1.89,2,12.31-.08,24.62,0,36.93,0h1c1.06,0,1.84.38,1.86,1.53S56.6,78,55.53,78H34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.59,27.64c0-4.12,0-8.25,0-12.37,0-1.61.65-2.26,2.25-2.25q11.68,0,23.36,0c1.14,0,2.18.2,2.2,1.53s-1,1.58-2.15,1.58c-6.87,0-13.74.06-20.61-.06-1.74,0-2,.5-2,2.07.09,7.33,0,14.66,0,22,0,1-.07,2.06-1.36,2.18s-1.74-.77-1.74-2C12.59,36.11,12.59,31.87,12.59,27.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.91,23.85c5.41-.84,8.51-3.71,9.22-9.27.77,5.54,3.87,8.41,9.26,9.3-5.51.75-8.38,3.84-9.27,9.23C47.39,27.59,44.29,24.73,38.91,23.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.25,50.14c2.09-.8,3.71-1.51,5.38-2a2.5,2.5,0,0,0,1.8-1.81c.57-1.72,1.25-3.4,2-5.34.76,2,1.46,3.74,2.06,5.5A2.27,2.27,0,0,0,27,48.07c1.72.57,3.4,1.25,5.33,2a25.71,25.71,0,0,1-5.1,2.08,2.8,2.8,0,0,0-1.9,1.93c-.56,1.66-1.21,3.3-1.94,5.26-.75-2-1.43-3.7-2-5.43a2.42,2.42,0,0,0-1.68-1.7C18,51.64,16.35,50.94,14.25,50.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M62.06,58c.72,1.93,1.34,3.42,1.84,5a3.15,3.15,0,0,0,2.35,2.36c1.62.44,3.16,1.17,4.95,1.86-2,.78-3.81,1.52-5.64,2.13a2,2,0,0,0-1.37,1.35c-.63,1.75-1.29,3.5-2,5.49a25.63,25.63,0,0,1-2-4.83A3.15,3.15,0,0,0,58,69c-1.63-.47-3.19-1.17-5.05-1.88,2-.78,3.78-1.51,5.58-2.11A2.14,2.14,0,0,0,60,63.59C60.59,61.85,61.26,60.13,62.06,58Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg32, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/32.9dc7cfbd.svg";
export { ForwardRef as ReactComponent };